import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import React from "react";

type SuccessfulRegistrationProps = {
  success: boolean;
  title: string;
  message: string;
  // specify how to open the modal
  setOpen: (open: boolean) => void;
  open: boolean;
  // specify how to close the modal
};
const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};
const SuccessfulRegistration: React.FC<SuccessfulRegistrationProps> = ({
  title,
  message,
  open,
  setOpen,
}) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={style}>
        <Stack spacing={2} alignItems="center">
          {/* Success Icon */}
          <CheckCircleIcon sx={{ fontSize: 60, color: "success.main" }} />

          {/* Title */}
          <Typography variant="h5" fontWeight={600}>
            {title}
          </Typography>

          {/* Message */}
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>

          {/* Button */}
          <Button
            variant="contained"
            color="success"
            size="large"
            onClick={() => setOpen(false)}
            sx={{ mt: 2, px: 4 }}
          >
            Ok
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default SuccessfulRegistration;
